import { render } from "./schedule.vue?vue&type=template&id=7bee9a53"
const script = {}
script.render = render

export default script